package com.example.hukakmp.model

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

@Serializable
data class PezCapturado(
    val especie: String = "",
    val cantidad: Int = 0,
    val observaciones: String? = null,
)

@Serializable
data class DeviceInfo(
    val modelo: String = "",
    val marca: String = "",
    val versionAndroid: String = "",
    val versionApp: String = "1.0",
)

/**
 * Modelo de datos unificado para los reportes de pesca, portado desde
 * Juka/app/.../data/firebase/ModelsFirebase.kt. `userInfo` (Map<String, Any>) se dejó afuera:
 * kotlinx.serialization no puede decodificar `Any` sin un serializer contextual, y ese campo
 * solo se usaba al guardar un parte nuevo (fuera del alcance de este milestone, que es
 * solo lectura).
 */
@Serializable
data class PartePesca(
    val id: String? = null,
    val userId: String? = null,
    val fecha: String? = null,
    val horaInicio: String? = null,
    val horaFin: String? = null,
    val timestamp: Timestamp? = null,
    val duracionHoras: String? = null,
    val deviceInfo: DeviceInfo? = null,
    val tipo: String? = null,
    val modalidad: String? = null,
    val modalidadOtra: String? = null,
    val cantidadTotal: Int = 0,
    val cantidadDevuelta: Int = 0,
    val observaciones: String? = null,
    val transcripcionOriginal: String? = null,
    val numeroCanas: Int? = 0,
    val estado: String? = null,
    val ubicacion: UbicacionParte? = null,
    val peces: List<Captura> = emptyList(),
    val fotos: List<String> = emptyList(),
)

@Serializable
data class UbicacionParte(
    val nombre: String? = null,
    val latitud: Double? = null,
    val longitud: Double? = null,
    val zona: String? = null,
)

@Serializable
data class Captura(
    val especie: String = "",
    val cantidad: Int = 0,
    val retenidos: Int = 0,
    val devueltos: Int = 0,
)

sealed class FirebaseResult {
    data object Success : FirebaseResult()
    data class Error(val message: String, val exception: Exception? = null) : FirebaseResult()
    data object Loading : FirebaseResult()
}
